
class CountDownService {

    // TODO: secondsLabel = this.$t('pages.controlpanel.index.controls.producer_control.stop_live_show.seconds') : ''
    formatTimer(timer, secondsLabel) {
        let hours, minutes, seconds, h,m,s;
        hours = parseInt(timer / 3600, 10);
        minutes = parseInt((timer - hours * 3600) / 60, 10);
        seconds = parseInt(timer % 60, 10);
        let t = new Date();
        t.setHours(hours, minutes, seconds, 0);

        h = hours < 10 ? "0" + hours : hours.toString();
        m = minutes < 10 ? "0" + minutes : minutes.toString();
        s = (seconds < 10 && (minutes > 0 || hours > 0)) ? "0" + seconds : seconds.toString();
        //
        let tt = [];
        if (hours > 0) {
            tt.push(h);
        }
        if (minutes > 0 || hours > 0) {
            tt.push(m);
        }
        tt.push(s + (minutes === 0 ? ' ' + secondsLabel : '')); // push anyway
        return tt;
    };
}

export default new CountDownService();
